import 'zod/compile';
import ReactDOM from 'react-dom/client';
import '@/common/translations/i18n';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { getEnv } from '@/common/utils/getEnv';
import { App } from './app';
import './styles.css';
import { datadogRum } from '@datadog/browser-rum';
import {
  setupAnalytics,
  trackPageView,
  updatePagePathSystemProperty,
} from '@/common/analytics/analytics';
import { initializeDatadogRUM } from '@/common/monitoring/datadogRum';
import { FeatureFlagOverrideProvider } from '@/common/providers/featureFlagOverrideContext';
import { router } from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const AppWithLDProvider = withLDProvider({
  clientSideID: getEnv().launchDarklyClientSideId,
  timeout: 5,
  options: {
    logger: {
      debug: () => undefined,
      info: () => undefined,
      warn: () => undefined,
      // biome-ignore lint/suspicious/noConsole: we want this logged
      error: console.error,
    },
    application: {
      id: 'spm-frontend',
      version: '0.1.0',
    },
  },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
})(App);

initializeDatadogRUM();
setupAnalytics();

router.subscribe('onResolved', ({ pathChanged }) => {
  if (pathChanged) {
    const matches = router.state.matches;
    const lastMatch = matches[matches.length - 1];
    const routePath = lastMatch?.routeId || '/';
    updatePagePathSystemProperty();
    trackPageView(routePath);
    datadogRum.startView({
      name: routePath,
    });
  }
});

root.render(
  <FeatureFlagOverrideProvider>
    <AppWithLDProvider />
  </FeatureFlagOverrideProvider>,
);
